<template>
  <div class="external-redirect flex flex-col items-center justify-center">
    <p class="font-semibold mb-4">
      Vous allez être redirigé vers un site externe...
    </p>
    <p v-if="url" class="italic">
      Si rien ne se passe,
      <a :href="url" class="underline" rel="noopener">cliquez ici</a>.
    </p>
    <p v-else class="text-carnation italic">
      < URL de redirection invalide. >
    </p>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';

const props = defineProps({
  url: {
    type: String,
    required: false
  }
});

onMounted(() => {
  if (props.url) {
    // Redirection vers l'URL externe après un délai de 2 secondes
    setTimeout(() => {
      window.location.href = props.url;
    }, 2000);
  }
});
</script>

<style scoped>
.external-redirect {
    min-height: inherit;
}
</style>
